import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)

const useStyles = makeStyles((theme) =>({
	container: {
		width: '90%', height: '550px', margin: '0 auto',
		[theme.breakpoints.down('md')]: {
			width: '100%'
		}
	}
}))

function Pictorial({ data, showMunicipios, level }) {
	const classes = useStyles()
	useEffect(
		() => {
			// Map instance
			const chart = am4core.create('chartdivbar', am4charts.XYChart)
			chart.hiddenState.properties.opacity = 0

			chart.paddingRight = 40
			chart.data = data
			var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis())
			categoryAxis.dataFields.category = 'name'
			categoryAxis.renderer.grid.template.strokeOpacity = 0
			categoryAxis.renderer.minGridDistance = 5
			categoryAxis.renderer.labels.template.dx = 0
			categoryAxis.renderer.labels.template.fontSize = 12
			categoryAxis.renderer.minWidth = 130
			categoryAxis.cursorTooltipEnabled = false
			categoryAxis.renderer.tooltip.dx = -10

			var valueAxis = chart.xAxes.push(new am4charts.ValueAxis())
			valueAxis.max = 100
			valueAxis.renderer.inside = false
			valueAxis.renderer.labels.template.fillOpacity = 0.3
			valueAxis.renderer.labels.template.fontSize = 12
			valueAxis.renderer.grid.template.strokeOpacity = 0
			valueAxis.min = 0
			valueAxis.cursorTooltipEnabled = false
			valueAxis.renderer.baseGrid.strokeOpacity = 0
			valueAxis.renderer.labels.template.dy = 20

			var series = chart.series.push(new am4charts.ColumnSeries())
			series.dataFields.valueX = 'value'
			series.dataFields.categoryY = 'name'
			series.tooltipText =
				'[bold]{valueX.value}% de presupuesto ejecutado[/] \nAlcalde: {alcalde}\nPresupuesto(S/): {presupuesto}'
			series.tooltip.pointerOrientation = 'vertical'
			series.tooltip.label.fontSize = 12
			series.tooltip.dy = -10
			series.columnsContainer.zIndex = 100

			var columnTemplate = series.columns.template
			columnTemplate.height = am4core.percent(40)
			columnTemplate.maxHeight = 35
			columnTemplate.column.cornerRadius(10, 10, 10, 10)
			columnTemplate.strokeOpacity = 0

			series.heatRules.push({
				target: columnTemplate,
				property: 'fill',
				dataField: 'valueX',
				min: am4core.color('#e5dc36'),
				max: am4core.color('#5faa46')
			})
			series.mainContainer.mask = undefined

			var cursor = new am4charts.XYCursor()
			chart.cursor = cursor
			cursor.lineX.disabled = true
			cursor.lineY.disabled = true
			cursor.behavior = 'none'

			/*var valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = "{value}%";
      valueLabel.label.fontSize = 12;
      valueLabel.label.interactionsEnabled = true;
      valueLabel.label.horizontalCenter = "left";*/

			if (level === 'province') {
				columnTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer
				series.columns.template.events.on(
					'hit',
					(ev) => {
						//showList(ev.target.dataItem.dataContext.id)
						const body = {
							province: ev.target.dataItem.dataContext.prov,
							alcalde: ev.target.dataItem.dataContext.alcalde,
							presupuesto: ev.target.dataItem.dataContext.presupuesto
						}
						showMunicipios(body)
					},
					this
				)

				categoryAxis.cursorOverStyle = am4core.MouseCursorStyle.pointer
				categoryAxis.renderer.labels.template.events.on(
					'hit',
					(ev) => {
						//showList(ev.target.dataItem.dataContext.id)
						const body = {
							province: ev.target.dataItem.dataContext.prov,
							alcalde: ev.target.dataItem.dataContext.alcalde,
							presupuesto: ev.target.dataItem.dataContext.presupuesto
						}
						showMunicipios(body)
					},
					this
				)
			
			}

			var cellSize = 35
			chart.events.on('datavalidated', function(ev) {
				// Get objects of interest
				var chart = ev.target
				var categoryAxis = chart.yAxes.getIndex(0)

				// Calculate how we need to adjust chart height
				var adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight

				// get current chart height
				var targetHeight = chart.pixelHeight + adjustHeight

				// Set it on chart's container
				chart.svgContainer.htmlElement.style.height = targetHeight + 'px'
			})

			return function cleanup() {
				chart && chart.dispose()
			}
		},
		[ data, showMunicipios, level ]
	)

	return <div id="chartdivbar" className={classes.container} />
}

export default Pictorial
